export const NOTE_TYPE_PROSPECT_QUOTE = "Prospect Quote";
export const NOTE_TYPE_HTML = "HTML Note";

export const OPPORTUNITY_NOTE_TYPES_WITH_HTML = [
  "Call",
  "Email",
  "Meeting",
  "Internal Discussion",
  "Negotiation Point",
  "Next Step",
  "General Note",
  NOTE_TYPE_HTML,
  NOTE_TYPE_PROSPECT_QUOTE,
  "Other",
];

/** @param {{ note_type?: string, note_content?: string }|null|undefined} note */
export const isHtmlOpportunityNote = (note) => {
  const content = String(note?.note_content || "").trim();
  if (!content) {
    return false;
  }
  if (
    note?.note_type === NOTE_TYPE_PROSPECT_QUOTE ||
    note?.note_type === NOTE_TYPE_HTML
  ) {
    return true;
  }
  return /<[a-z][\s\S]*>/i.test(content);
};

/** @param {string} html */
export const copyHtmlToClipboard = async (html) => {
  const text = String(html || "").trim();
  if (!text) {
    throw new Error("Nothing to copy.");
  }
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(text);
    return;
  }
  const textarea = document.createElement("textarea");
  textarea.value = text;
  textarea.setAttribute("readonly", "");
  textarea.style.position = "absolute";
  textarea.style.left = "-9999px";
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand("copy");
  document.body.removeChild(textarea);
};
